import authLocale from './en.json'

const en = {
  auth: authLocale,
}

export default en
